const log = require("../shared_utils/log.js");

module.exports = function store(state, emitter) {
  emitter.on("swap-selected-item", (itemId) => {
    log("swap-selected-item", itemId);
    const index = state.toolbar.items.findIndex((id) => id === itemId);
    const selectedItemId = state.selectedGlitchId || state.selectedPartId;
    const selectedItemIndex = state.toolbar.items.findIndex(
      (id) => id === selectedItemId
    );
    const hoverItemId = state.toolbar.items[index];
    state.toolbar.items[index] = selectedItemId;
    state.toolbar.items[selectedItemIndex] = hoverItemId;
    emitter.emit("render");
  });

  emitter.on("start-moving-glitch", (glitchId) => {
    log("start-moving-glitch");
    state.movingGlitch = true;
    emitter.emit("select-glitch", glitchId);
  });

  emitter.on("start-moving-part", (partId) => {
    log("start-moving-part");
    state.movingPart = true;

    emitter.emit("select-part", partId);
  });

  emitter.on("remove-glitch-from-toolbar", (glitchId) => {
    log("remove-glitch-from-toolbar");
    const i = state.toolbar.glitches.findIndex((id) => id === glitchId);
    state.toolbar.glitches.splice(i, 1);
    const i2 = state.toolbar.items.findIndex((id) => id === glitchId);
    state.toolbar.items.splice(i2, 1);
    state.toolbar = JSON.parse(JSON.stringify(state.toolbar)); // force update
    emitter.emit("render");
  });
  emitter.on("remove-part-from-toolbar", (partId) => {
    const i = state.toolbar.parts.findIndex((id) => id === partId);
    state.toolbar.parts.splice(i, 1);
    const i2 = state.toolbar.items.findIndex((id) => id === partId);
    state.toolbar.items.splice(i2, 1);

    emitter.emit("render");
  });
};
